export const getPowerDocText = (content: any) => {
  return (content?.blocks || []).map((b: any) => (b.children || []).map((c: any) => c.text || "").join("")).join("\n");
};
